import type { selectRes } from "../SideBarTypes";

export function collectFolderIdsFromTree(rootFolders: any[]): string[] {
    const ids: string[] = [];
    const stack = [...rootFolders];

    while (stack.length) {
        const f = stack.pop();
        if (!f?._id) continue;

        ids.push(String(f._id));

        if (Array.isArray(f.folders)) {
            for (const child of f.folders) {
                if (child && typeof child === "object") stack.push(child);
            }
        }
    }

    return ids;
}




export function collectFolderSubtreeForSelection(folder: any): selectRes[] {
    const out: selectRes[] = [];
    const stack = [folder];

    while (stack.length) {
        const f = stack.pop();
        if (!f?._id) continue;
        out.push({ id: String(f._id), resType: "folder" });
        for (const snipId of (f.snippets ?? [])) {
            out.push({ id: String(snipId), resType: "snippet" });
        }
        for (const fileId of (f.fileRefs ?? [])) {
            out.push({ id: String(fileId), resType: "file" });
        }
        if (Array.isArray(f.folders)) {
            for (const child of f.folders) {
                if (child && typeof child === "object") stack.push(child);
            }
        }
    }

    return out;
}